<template>
    <TemplateContentPage :entry="entry" />
</template>

<script setup lang="ts">
import PageQuery from '~/graphql/queries/Page.graphql';
import type { PageEntryTypeFragment, ProgramOverviewEntryTypeFragment, PageQuery as PageQueryType } from '~/types/craft-schema';

const route = useRoute();

const queryVariables = computed(() => ({
    uri: useNormalizePath(route.path)
}));

const response = await useAsyncQuery<PageQueryType>({
    query: PageQuery,
    variables: queryVariables
});

const entry = useCraftEntry<PageEntryTypeFragment | ProgramOverviewEntryTypeFragment>(response);
</script>
